import { useCallback, useState } from "react";
import { hasSelectedLocation, readUserDataFromLocalStorage } from "modules/main/services/location-storage";

/**
 * Enforces location selection for guest users before cart actions.
 */
export const useRequireLocationForCart = () => {
    const [isLocationDialogOpen, setIsLocationDialogOpen] = useState(false);
    const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

    const executeWithLocationRequirement = useCallback(
        (action: () => void) => {
            const userData = readUserDataFromLocalStorage();
            const requiresLocationSelection = !hasSelectedLocation(userData);

            if (requiresLocationSelection) {
                setPendingAction(() => action);
                setIsLocationDialogOpen(true);
                return false;
            }

            action();
            return true;
        },
        [],
    );

    const handleLocationSelected = useCallback(() => {
        setIsLocationDialogOpen(false);
        if (pendingAction) {
            const action = pendingAction;
            setPendingAction(null);
            action();
        }
    }, [pendingAction]);

    const handleLocationDialogOpenChange = useCallback((open: boolean) => {
        setIsLocationDialogOpen(open);
        if (!open) {
            setPendingAction(null);
        }
    }, []);

    return {
        isLocationDialogOpen,
        executeWithLocationRequirement,
        handleLocationSelected,
        handleLocationDialogOpenChange,
    };
};
